import { Handshake, Mail, MapPin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section" data-testid="footer">
      {/* Main Footer Content */}
      <div className="container-main pt-16 pb-12 md:pt-20 md:pb-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-y-12 gap-x-10 lg:gap-x-12">
          {/* Brand Column */}
          <div className="sm:col-span-2 lg:col-span-4">
            <h3 className="text-2xl font-bold text-white mb-4" data-testid="footer-brand">
              Solve<span className="text-[#10B981]">Debts</span>
            </h3>
            <p className="text-slate-400 mb-6 text-sm leading-relaxed max-w-sm">
              We connect UK residents with FCA regulated debt solution providers.
              Free, no-obligation introductions to help you find the right debt solution.
            </p>
            <div className="inline-flex items-center gap-3 bg-slate-800/60 border border-slate-700/60 rounded-xl px-4 py-3">
              <div className="w-9 h-9 bg-emerald-900/50 rounded-lg flex items-center justify-center flex-shrink-0">
                <Handshake className="w-4 h-4 text-[#10B981]" />
              </div>
              <div>
                <p className="text-white font-medium text-sm leading-tight">Trusted Introductions</p>
                <p className="text-slate-500 text-xs leading-tight mt-0.5">To FCA Regulated Firms</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h4 className="text-white font-semibold mb-5 text-xs uppercase tracking-[0.15em]">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-slate-400 hover:text-[#10B981] transition-colors text-sm">About IVAs</a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-[#10B981] transition-colors text-sm">Debt Solutions</a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-[#10B981] transition-colors text-sm">How It Works</a>
              </li>
              <li>
                <a href="#faq-section" className="text-slate-400 hover:text-[#10B981] transition-colors text-sm">FAQs</a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-[#10B981] transition-colors text-sm">Contact Us</a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-3">
            <h4 className="text-white font-semibold mb-5 text-xs uppercase tracking-[0.15em]">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#10B981] flex-shrink-0 mt-0.5" />
                <a href="mailto:hello@solvedebts.co.uk" className="text-slate-400 hover:text-[#10B981] transition-colors text-sm break-all">
                  hello@solvedebts.co.uk
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#10B981] flex-shrink-0 mt-0.5" />
                <span className="text-slate-400 text-sm leading-relaxed">United Kingdom</span>
              </li>
            </ul>
          </div>

          {/* About Us */}
          <div className="lg:col-span-3">
            <h4 className="text-white font-semibold mb-5 text-xs uppercase tracking-[0.15em]">About Us</h4>
            <p className="text-slate-400 text-sm leading-relaxed">
              SolveDebts is an introduction service. We are not debt advisors. We introduce you to FCA regulated debt management companies who can assess your situation.
            </p>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="container-main">
        <div className="h-px bg-slate-800"></div>
      </div>

      {/* Compliance Footer */}
      <div className="container-main pt-10 pb-8">
        <div className="space-y-6">
          <p className="text-slate-500 text-xs leading-relaxed text-center max-w-4xl mx-auto">
            SolveDebts is a trading style of Connexis Group Ltd. Registered in England and Wales.
            SolveDebts is not a debt advisor. We are an introduction service that connects you with FCA regulated debt solution providers.
            We do not provide debt advice or debt management services directly.
          </p>
          <p className="text-slate-500 text-xs leading-relaxed text-center max-w-4xl mx-auto">
            <strong className="text-slate-400">Important:</strong> An Individual Voluntary Arrangement (IVA) is a formal insolvency procedure.
            It may not be suitable for everyone and could affect your credit rating. Your home may be at risk if you
            do not keep up repayments on a mortgage or any other debt secured on it. Fees apply. Subject to eligibility and approval.
            The debt solution providers we introduce you to are authorised and regulated by the Financial Conduct Authority.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 pt-4">
            <a href="#" className="text-slate-500 hover:text-slate-300 text-xs transition-colors">Privacy Policy</a>
            <span className="text-slate-700 text-xs">•</span>
            <a href="#" className="text-slate-500 hover:text-slate-300 text-xs transition-colors">Terms & Conditions</a>
            <span className="text-slate-700 text-xs">•</span>
            <a href="#" className="text-slate-500 hover:text-slate-300 text-xs transition-colors">Cookie Policy</a>
            <span className="text-slate-700 text-xs">•</span>
            <a href="#" className="text-slate-500 hover:text-slate-300 text-xs transition-colors">Complaints Procedure</a>
          </div>

          <p className="text-slate-600 text-xs text-center pt-2">
            &copy; {currentYear} SolveDebts | Connexis Group Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
